import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';

import { useCurrentUser } from 'hooks/api/use-current-user';

interface NotificationPointProps {
  isNoContent?: boolean;
  type?: 'files' | 'insights';
}

const NotificationPoint = ({
  isNoContent = false,
  type = 'files',
}: NotificationPointProps): React.JSX.Element | null => {
  const [newAssetsNumber, setNewAssetsNumber] = useState<number | string>(0);
  const fetchedRef = useRef(false);

  const user = useCurrentUser();

  const baseStyles =
    'rounded-full bg-critical-500 w-2 h-2 flex items-center justify-center';

  useEffect(() => {
    if (!isNoContent && user && !fetchedRef.current) {
      fetchedRef.current = true;

      if (type === 'insights') {
        user.setNewInsightsCount?.();
      } else {
        user.setNewFilesCount?.();
      }
    }
  }, [type, isNoContent]);

  useEffect(() => {
    const count = type === 'insights' ? user.insightsCount : user.filesCount;
    const currentNewAssetsNumber = count < 10 ? count : '9+';

    setNewAssetsNumber(currentNewAssetsNumber);
  }, [user.filesCount, user.insightsCount, type]);

  if (isNoContent) {
    return (
      <div
        className={classNames(
          baseStyles,
          'absolute border-2 border-white p-1.5 left-[31%] md:left-[30%] lg:left-[34%] xl:left-[35%]'
        )}
        data-testid="notification-point-no-content"
        aria-hidden="true"
      ></div>
    );
  }

  if (!newAssetsNumber) return null;

  return (
    <div
      className={classNames(
        baseStyles,
        'absolute xs:right-[-14px] xs:-top-2.5 p-2.5'
      )}
      data-testid="notification-point-with-content"
      aria-hidden="true"
    >
      <span className="text-white text-xs md:text-sm mb-px">
        {newAssetsNumber}
      </span>
    </div>
  );
};

export default NotificationPoint;
